import { render, staticRenderFns } from "./bigVideo.vue?vue&type=template&id=f6c7389c&scoped=true"
import script from "./bigVideo.vue?vue&type=script&lang=js"
export * from "./bigVideo.vue?vue&type=script&lang=js"
import style0 from "./bigVideo.vue?vue&type=style&index=0&id=f6c7389c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c7389c",
  null
  
)

export default component.exports